import { render } from "./DinamicForm.vue?vue&type=template&id=252927f6"
import script from "./DinamicForm.vue?vue&type=script&lang=js"
export * from "./DinamicForm.vue?vue&type=script&lang=js"

import "./DinamicForm.vue?vue&type=style&index=0&id=252927f6&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__